/* apps/viewer/src/app/content-provider/content-provider.component.scss */
.ori-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0);
}
.ori-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1);
}
.ori-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2);
}
.ori-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3);
}
.ori-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4);
}
.ori-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5);
}
.ori-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6);
}
.ori-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7);
}
.ori-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8);
}
.ori-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9);
}
.ori-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10);
}
.ori-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11);
}
.ori-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12);
}
.ori-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13);
}
.ori-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14);
}
.ori-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15);
}
.ori-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16);
}
.ori-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17);
}
.ori-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18);
}
.ori-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19);
}
.ori-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20);
}
.ori-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21);
}
.ori-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22);
}
.ori-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23);
}
.ori-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24);
}
:host {
  display: flex;
  height: 100%;
  min-height: calc(100vh - 60px);
}
:host table.content-provider-table,
:host table.content-provider-table thead,
:host table.content-provider-table tbody,
:host table.content-provider-table tr,
:host table.content-provider-table td,
:host table.content-provider-table th {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
@media only screen {
  :host table.content-provider-table,
  :host table.content-provider-table thead,
  :host table.content-provider-table tbody,
  :host table.content-provider-table tr,
  :host table.content-provider-table td,
  :host table.content-provider-table th {
    display: block;
    width: 100%;
  }
}
:host table.content-provider-table .disclaimer-top {
  display: none;
}
:host.player_mode {
  position: absolute;
}
:host.player_mode ::ng-deep .media-sticky {
  position: unset !important;
  width: 0 !important;
}
:host.player_mode ::ng-deep o-panzoom {
  display: none !important;
}
:host.player_mode ::ng-deep .draggable-container {
  display: none !important;
}
:host.player_mode ::ng-deep o-fulltext .more {
  display: none;
}
:host.player_mode ::ng-deep o-fulltext .content #wrapper {
  max-height: calc(100vh - 250px);
  overflow-x: hidden;
}
:host.player_mode ::ng-deep o-media-container .media-actions {
  display: none !important;
}
::ng-deep .msm_table {
  display: flex;
  margin: 10px 0;
}
::ng-deep .msm_header {
  display: flex;
}
::ng-deep .msm_header .o-table {
  width: 100%;
}
::ng-deep .initial_table,
::ng-deep .initial_header {
  border: solid 1px #aaa;
  border-left: none;
  display: none;
  width: 100px;
}
::ng-deep .initial_table {
  margin: 10px 0;
}
::ng-deep .initial_header {
  align-items: center;
  font-size: 10pt;
  font-weight: bold;
  justify-content: center;
  margin-bottom: 1em;
}
::ng-deep .display_none {
  display: none;
}
@media screen {
  ::ng-deep mat-sidenav-content.applicable-content o-media .media__wrapper:has(.notApplicableMedia) {
    filter: brightness(0.75);
  }
  ::ng-deep mat-sidenav-content.non-applicable-content {
    height: inherit !important;
  }
  ::ng-deep mat-sidenav-content.non-applicable-content o-ipc,
  ::ng-deep mat-sidenav-content.non-applicable-content o-fulltext main .fulltext-content,
  ::ng-deep mat-sidenav-content.non-applicable-content o-fulltext main .media-sticky,
  ::ng-deep mat-sidenav-content.non-applicable-content o-fulltext .encapsulated_pdf,
  ::ng-deep mat-sidenav-content.non-applicable-content o-fulltext o-thumbs {
    filter: brightness(0.75);
  }
  ::ng-deep mat-sidenav-content.non-applicable-content o-pdf,
  ::ng-deep mat-sidenav-content.non-applicable-content o-ipc mat-sidenav-container,
  ::ng-deep mat-sidenav-content.non-applicable-content o-ipc-view {
    height: calc(100vh - 60px - 40px) !important;
  }
  ::ng-deep mat-sidenav-content.non-applicable-content o-ipc mat-sidenav-container {
    min-height: calc(100vh - 60px - 40px) !important;
  }
}
:host(.not-applicable) {
  min-height: calc(100vh - 60px - 40px);
}
:host(::ng-deep.line-through-inline) {
  text-decoration: line-through;
}
:host(::ng-deep.hide-inline) {
  display: none !important;
}
::ng-deep .hide-applic-inline-header,
.disclaimer-top,
.only-print {
  display: none;
}
@media (orientation: landscape) {
  .half-view {
    width: 50%;
  }
}
@media print {
  .half-view {
    width: 100%;
  }
}
.preprint-fullscreen {
  background-color: #fb8033;
  fill: #fafafa;
}
.router-outlet-wrap {
  width: 100%;
}
.mma-wrap ::ng-deep .content .DU_CONTENT > ol {
  padding-left: 12px;
}
.warning-ipc {
  display: none;
}
.dm-items-container {
  height: 100%;
  min-height: 0;
  width: 100%;
}
.dm-items-container .dm-items-sidenav {
  margin-top: 60px;
  max-width: 700px;
  width: 80%;
}
.dm-items-container .dm-items-sidenav.withBand {
  margin-top: 100px;
}
@media (orientation: portrait) {
  .dm-items-container .dm-items-sidenav.withBand.side-by-side {
    margin-top: 60px !important;
  }
}
.dm-items-container .dm-items-sidenav .close-drawer {
  display: flex;
  justify-content: end;
}
.dm-items-container .dm-items-sidenav .dm-items-list {
  margin: 10px;
}
.dm-items-container .dm-items-sidenav .dm-items-list.invisible {
  display: none;
}
.dm-items-container .dm-items-sidenav .dm-items-list ::ng-deep .mat-expansion-indicator {
  padding-bottom: 5px;
}
.dm-items-container .dm-items-sidenav ::ng-deep input,
.dm-items-container .dm-items-sidenav ::ng-deep textarea,
.dm-items-container .dm-items-sidenav ::ng-deep form {
  cursor: default !important;
}
.header__not-applicable {
  align-items: center;
  background: #fb8033;
  box-shadow:
    0 3px 5px -1px rgba(0, 0, 0, 0.2),
    0 6px 10px 0 rgba(0, 0, 0, 0.14),
    0 1px 18px 0 rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  font-size: 1.2em;
  font-weight: bold;
  height: 40px;
  justify-content: center;
  z-index: 6;
}
.header__not-applicable mat-icon {
  height: 30px;
  margin-right: 20px;
  width: 30px;
}
.left {
  float: left;
}
.disclaimer-reference {
  display: none;
}
.disclaimer-message {
  align-items: center;
  display: flex;
}
.disclaimer-message span {
  padding: 1vh 0;
}
@media print {
  :host {
    display: block;
  }
  :host table.content-provider-table tr {
    page-break-inside: unset;
  }
  :host.hide-print-applic ::ng-deep .applic-filter {
    display: none;
  }
  :host.hide-print-applic ::ng-deep .adding-disclaimer {
    display: none;
  }
  :host.hide-print-applic ::ng-deep .line-through-inline {
    text-decoration: none;
  }
  :host.hide-print-applic ::ng-deep .hide-inline {
    display: block !important;
  }
  :host.hide-print-applic ::ng-deep .applic-inline-header {
    display: flex !important;
  }
  ::ng-deep .mat-expansion-indicator {
    display: none !important;
  }
  ::ng-deep .mat-expansion-panel-content-wrapper {
    grid-template-rows: 1fr !important;
  }
  ::ng-deep .mat-expansion-panel-content {
    visibility: visible !important;
  }
  ::ng-deep .mat-expansion-panel-header-title {
    color: #00205b !important;
    font-size: 18px !important;
  }
  .dm-items-list {
    background-color: unset;
    box-shadow: unset !important;
  }
  .note_drawer_button,
  .close-button {
    display: none;
  }
  .warning-ipc,
  .only-print {
    display: block;
  }
  ::ng-deep .mat-drawer-inner-container {
    display: block !important;
  }
  .dm-items-container {
    background-color: transparent;
  }
  .dm-items-container .dm-items-sidenav {
    box-shadow: none;
    display: block;
    height: auto;
    margin: 0;
    page-break-after: always !important;
    position: relative;
    transform: none;
    visibility: visible !important;
    width: 95%;
  }
  .dm-items-container .dm-items-sidenav.withBand {
    margin-top: 0;
  }
  .dm-items-container .no-dm-items {
    display: none;
  }
  .dm-items-container .dm-items-content .close-button {
    display: none;
  }
  .dm-items-container .dm-items-content ::ng-deep o-note mat-card,
  .dm-items-container .dm-items-content ::ng-deep o-comment mat-card {
    page-break-inside: avoid;
  }
  .note--export-menu-button {
    display: none;
  }
  .header__not-applicable {
    display: none;
  }
  ::ng-deep .not-applicable {
    background: transparent !important;
  }
  .safariContent ::ng-deep o-fulltext .fulltext-content,
  .safariContent ::ng-deep o-wdm-view .wdm-content,
  .safariContent ::ng-deep o-ipc o-ipc-toc {
    padding-right: 0 !important;
  }
  .safariContent ::ng-deep o-thumbs .thumbs-container {
    margin-right: 0;
  }
  .safariContent ::ng-deep .end-document {
    page-break-after: always;
  }
  .cordovaContent ::ng-deep o-fulltext ::ng-deep .listChildNumerotation::after,
  .cordovaContent ::ng-deep o-fulltext ::ng-deep .text-procedural-step::before {
    font-size: 24px;
    font-weight: normal;
    line-height: 24px;
  }
  .cordovaContent ::ng-deep o-fulltext ::ng-deep .set-up + ::ng-deep .AHX4_proced_level_content_class ::ng-deep .proced_level_chip_type2_class::before,
  .cordovaContent ::ng-deep o-fulltext ::ng-deep .close-up + ::ng-deep .AHX4_proced_level_content_class ::ng-deep .proced_level_chip_type2_class::before {
    font-size: 24px;
    font-weight: normal;
  }
  .iosContent ::ng-deep .thumb ::ng-deep .media__type,
  .iosContent ::ng-deep .thumb .media__type > * {
    height: calc(100% - 4cm) !important;
  }
  .iosContent ::ng-deep .end-document {
    page-break-after: always;
  }
  .disclaimer-reference {
    color: #aaa;
    display: block;
    font-size: 10px;
    height: calc(100vh - 40px);
    margin: 40px 0;
    position: fixed;
    right: 0;
    text-orientation: mixed;
    top: 0;
    writing-mode: vertical-rl;
    z-index: 9999;
  }
  .disclaimer-reference.safari {
    height: unset;
    margin: auto;
    margin-bottom: 15px;
    position: unset;
    width: 100%;
    writing-mode: horizontal-tb;
  }
  ::ng-deep .disclaimer-top {
    color: #aaa;
    display: flex !important;
    flex-direction: column;
    font-size: 10px;
    width: 100%;
  }
  ::ng-deep .disclaimer-top.safari {
    position: unset;
  }
  ::ng-deep .disclaimer-top.safari .right {
    margin-right: 0;
  }
  ::ng-deep .disclaimer-top.safari .adding-disclaimer {
    margin-bottom: 0;
  }
  ::ng-deep .disclaimer-top h5 {
    color: #878787;
    font-size: 10px;
    font-weight: normal;
  }
  ::ng-deep .disclaimer-top .left {
    width: 60%;
  }
  ::ng-deep .disclaimer-top .right {
    text-align: right;
    width: 40%;
  }
  .black {
    color: #212121;
  }
  .adding-disclaimer {
    color: red;
    text-transform: uppercase;
  }
  .applic-filter {
    color: red;
  }
  .sensitive-message {
    color: black;
    font-size: small;
    font-weight: bold;
    white-space: nowrap;
  }
  .data-disclosure {
    color: red;
    font-size: small;
    font-weight: bold;
    white-space: nowrap;
  }
  ::ng-deep .initial_table {
    display: block;
  }
  ::ng-deep .initial_header {
    display: flex;
  }
  ::ng-deep .with_initial {
    display: flex;
  }
  ::ng-deep .msm_table {
    page-break-inside: avoid;
  }
}
/*# sourceMappingURL=content-provider.component.css.map */
